module.exports = __webpack_public_path__ + "img/Checkmark.dfa01f76.svg";